/**
 * @desc getCabinInfoByAoNo
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<Array<defs.tms.CabinLinkAllocationResponseDto>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/cabinMaster/getCabinInfoByAoNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
